import { ChannelConfigDetailPage } from "@/features/channel-config/pages/ChannelConfigDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/channel-config/$channelId")({
	component: RouteComponent,
});

function RouteComponent() {
	const { channelId } = Route.useParams();
	return <ChannelConfigDetailPage channelID={channelId} />;
}
